import Modal from './Modal';
import ModalCard from './ModalCard';
import ModalSubmit from './ModalSubmit';

export { ModalCard, ModalSubmit };
export default Modal;
